import React from "react";
import { ProductItemComponentProps } from "../../constants/interface.ts";
import { useTranslation } from "react-i18next";
import IconCardComponent from "../IconCardComponent/IconCardComponent.tsx";

const ProductBenefitsComponent = (props: ProductItemComponentProps) => {
    const { title = '', paragraph = '', img = '', list = [], } = props;
    const {t} = useTranslation();

    return (
        <div className="flex flex-col gap-8 lg:gap-16">
            <div className="flex flex-col gap-5">
                <p className="text-3xl font-semibold text-black-1A1 lg:text-4xl">{t(title)}</p>
                <>
                {
                    (paragraph) &&
                    <p className="text-base font-normal text-gray-535 lg:text-xl lg:max-w-[40rem]">{t(paragraph)}</p>
                }
                </>
            </div>
            <div className="grid gap-16 lg:gap-10 lg:grid-cols-[1fr,31.25rem]">
                <div className="grid sm:grid-cols-2">
                    {
                        list?.map((item, index: number) => (
                            <React.Fragment key={index}>
                                <IconCardComponent
                                    img={item.img || ''}
                                    imgContainerClass={'bg-white border border-gray-E9E'}
                                    title={item.title || ''}
                                    titleClass={'text-black-1A1'}
                                    paragraph={item.paragraph || ''}
                                    paragraphClass={'text-gray-535'}
                                    index={index}
                                    list={item.list || []}
                                />
                            </React.Fragment>
                        ))
                    }
                </div>
                <div
                    className="relative bg-cover w-full h-[23.125rem] rounded-md bg-gray-DDE lg:h-full lg:rounded-lg"
                    style={{ backgroundImage: `url('${img}')`}}
                ></div>
            </div>
        </div>
    );
};

export default ProductBenefitsComponent;